import React from 'react';
import { Notification, RecordsTable, STATUS_TYPES } from 'dyl-components';
import HolidayScheduleHeader from './Header';
import HolidayScheduleRow from './Row';
import { useDispatch, useSelector } from 'react-redux';
import pbxConfigActions from 'actions/pbx_config';
import { useEffect } from 'react';

export const HolidayScheduleTable = ({ onEdit, onDuplicate }) => {

    const dispatch = useDispatch();
    const { holidaySchedules, isReadingHolidaySchedules, holidaySchedulesCount } = useSelector((state) => state.pbx_config);

    useEffect(() => {
        dispatch(pbxConfigActions.getHolidaySchedules());
    }, [dispatch])

    const onDelete = async (id) => {
        try {
            await dispatch(pbxConfigActions.deleteHolidaySchedule(id));
            dispatch(pbxConfigActions.getHolidaySchedules());
            Notification.alert('Holiday Schedule deleted successfully', STATUS_TYPES.SUCCESS, true);
        } catch (error) {
            Notification.alert('Failed to delete Holiday Schedule', STATUS_TYPES.ERROR, true);
        }
    }

    return (
        <RecordsTable
            isTableLoading={isReadingHolidaySchedules}
            isTableEmpty={!holidaySchedulesCount}
            hasPagination={false}
            TableHeader={
                <HolidayScheduleHeader />
            }
            TableRows={holidaySchedules?.map((holidaySchedule) => {
                return <HolidayScheduleRow holidaySchedule={holidaySchedule} onDelete={onDelete} onEdit={onEdit} onDuplicate={onDuplicate} isDuplicateDisable={holidaySchedulesCount >= 10} />
            })}
            recordsCount={holidaySchedulesCount}
            recordsName='Holiday Schedule'
            emptyListTitle="No Holiday Schedule Created"
            emptySubtitleHidden
            noBorder
        />
    );
}

